import React from 'react'

import SliteHome from './home'

export default function SliteHomepage() {
  return <SliteHome />
}
